import { TimeReport_GetCustomerContacts } from "@bonliva-crm/graphql";
// **
// **
// **
//Email template for manual send out to approve timeReport by customer

export const getSubject = (week: string, shortConsultantName: string) => {
  if (shortConsultantName) {
    return `Tidrapport ${shortConsultantName}, ${week}`;
  }
  return "";
};

export const getBody = (week: string, shortConsultantName: string, company: string) => {
  return `<p>Hej,</p>
          <p>
            Stämmer konsulten ${shortConsultantName} tjänstgöring från ${week}? Följ länken nedan för att finna tidrapporten och klicka Godkänn om allt är korrekt. Om något inte stämmer har du möjlighet att klicka Neka med kommentar.
          </p>
           <p>
            Sjukdom/VAB har vi som rutin att dubbelkolla med verksamheten.
          </p>
          <p>
            Eventuell milersättning/andra utlägg/sjuklön som kan stå med på tidrapporten står ${company} för som arbetsgivare.
          </p>
          <p>
          Tacksam för snar hantering! 🙂<br>
          OBS! Funkar inte länken? Testa att öppna detta med annan webbläsare som t.ex. Google Chrome, Edge etc.
          </p>`;
};

export const getRecipients = (
  contactPersons: TimeReport_GetCustomerContacts.Return["contacts"]
) =>
  contactPersons
    // A contact person without an email is not a recipient — offering it as a
    // suggestion is how a timereport ended up "sent" to a blank address
    // (CRMDEV-7141).
    ?.filter((x) => x.Email?.trim())
    .map((x) => {
      const responsibleRole = x.Roles.filter((r) => r === "Attestering").join(", ");
      return {
        value: x.Email,
        label: `${x.Email} ${responsibleRole ? `- ${responsibleRole}` : ""}${
          x.Title ? ` - ${x.Title}` : ""
        }`
      };
    }) ?? [];

export const positiveTGCostCenters = [
  "10",
  "15",
  "20",
  "21",
  "22",
  "25",
  "30",
  "40",
  "50",
  "52"
];
export const belowTwelveTGCostCenters = [];
export const belowFifteenTGCostCenters = ["69", "82"];
export const belowTenTGCostCenters = [
  "31", // Psychology team
  "32", // Psychology team
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "80",
  "81",
  "83",
  "85"
];
